import gql from 'graphql-tag'

export const CREATE_DATASET = gql`
  mutation CreateDataSet(
    $name: String!
    $description: String!
    $dataPoints: String!
    $userId: ID!
  ) {
    createDataSet(
      name: $name
      description: $description
      authorId: $userId
      dataPoints: $dataPoints
    ) {
      id
      name
      description
      createdAt
      updatedAt
      dataPoints
      author {
        id
        name
      }
      charts {
        id
      }
    }
  }
`

export const UPDATE_DATASET = gql`
  mutation UpdateDataSet($datasetId: ID!, $dataPoints: String!) {
    updateDataSet(id: $datasetId, dataPoints: $dataPoints) {
      id
      name
      description
      createdAt
      updatedAt
      dataPoints
      author {
        id
        name
      }
      charts {
        id
      }
    }
  }
`

export const DELETE_DATASET = gql`
  mutation DeleteDataSet($datasetId: ID!) {
    deleteDataSet(id: $datasetId) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/dataset.js